import type { AnyHTMLInputElementType } from "@mcwd/typescript-type-guards";


export const getRawInputElementCheckedValue = (mktoInput: AnyHTMLInputElementType) =>
{
  return $(mktoInput).prop("checked") === true;
};
